export const STORAGE_KEY = "user";

export const sessionService = {
  /**
   * Guarda el usuario en localStorage y dispara un evento para que los componentes (como Navbar) se enteren.
   */
  saveUser: (user: any) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(user));
      // Disparar evento custom para mantener sincronizados componentes legacy
      window.dispatchEvent(new Event("auth:changed"));
      window.dispatchEvent(new Event("storage"));
    } catch (e) {
      console.error("Error saving session", e);
    }
  },

  /**
   * Obtiene el usuario actual de localStorage. Retorna null si no existe o hay error de parseo.
   */
  getCurrentUser: (): any | null => {
    try {
      const userStr = localStorage.getItem(STORAGE_KEY);
      if (!userStr) return null;
      return JSON.parse(userStr);
    } catch (e) {
      console.error("Error parsing user session", e);
      return null;
    }
  },

  /**
   * Elimina la sesión del usuario del localStorage.
   */
  destroySession: () => {
    try {
      localStorage.removeItem(STORAGE_KEY);
      window.dispatchEvent(new Event("auth:changed"));
      window.dispatchEvent(new Event("storage"));
    } catch (e) {
      console.error("Error destroying session", e);
    }
  },
};
